
import React, { Component } from 'react';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { FormattedMessage } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLFormService } from 'ml-services-common-react';
import { MLModalService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLTagManagerService } from 'ml-portals-services-react'

import PropTypes from 'prop-types';
import appConfig from 'app-config';
import _ from 'lodash';

import metadata from './MLAccountBillingRequiredSignature.metadata.json5';
import messages from './MLAccountBillingRequiredSignature.messages';
import styles from './MLAccountBillingRequiredSignature.module.scss';

import { InputField, DropdownSelectField, InputMaskField } from '@jutro/legacy/components';

import { TranslatorContext, withIntl } from '@jutro/legacy/locale';

const { MLUserTypes, MLProducerTypes, MLFormNumberWildcards } = appConfig;

const {
    showProgressDialog
} = MLModalService();

// account/MLESignatureCtrl, ml-required-signatures-billing
class MLAccountBillingRequiredSignature extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        location: PropTypes.shape({
            state: PropTypes.string,
            pathname: PropTypes.string
        }).isRequired,

        authenticated: PropTypes.bool.isRequired,
        authHeader: PropTypes.shape({}).isRequired,
    };

    constructor(props) {
        super(props);

        const { viewModelService } = props;
        const { emailAddress1 } = this.props.accountDetailsData.accountHolder;
        const {
            bundledPaymentRequest,
            paymentInstrument,
            totalPaymentAmount,
            isGpa,
            usePaymentusAch
        } = this.props.history.location.state;

        this.state = {
            refresh: false,
            bundledPaymentRequest: bundledPaymentRequest,
            usePaymentusAch: usePaymentusAch,
            paymentInstrument: paymentInstrument,
            totalPaymentAmount: totalPaymentAmount,
            isGpa: isGpa,
            onetimePaymentForm: viewModelService.create({}, 'pc', 'metlife.edge.capabilities.forms.dto.FormDTOML'),
            signatureTypeList: viewModelService.productMetadata.get('pc').types.getTypelist('SignatureType_ML').codes
                .filter((sigType) => { return sigType.code !== 'verbal' && sigType.code !== 'signature_on_file'; }),
            appSignatureTypeList: viewModelService.productMetadata.get('pc').types.getTypelist('SignatureType_ML').codes
                .filter((sigType) => { return sigType.code !== 'verbal'; })
        }

        this.state.onetimePaymentForm.namedInsuredEmail.value = emailAddress1;
    }

    refreshData = () => {
        this.setState((prevState) => ({ refresh: !prevState.refresh }));
    };

    isMetGaUser = () => {
        return (this.props.authUserData.userType === MLUserTypes.PCS
            && this.props.authUserData.primaryProducerCode_ML.producerType_ML === MLProducerTypes.IA)
            || this.props.authUserData.userType === MLUserTypes.MET_GA;
    };

    isPCSAgent = () => {
        return this.props.authUserData.userType === MLUserTypes.PCS;
    };

    isIAAgent = () => {
        return this.props.authUserData.userType === MLUserTypes.IA;
    };

    isSignatureOnFileAvailable = (form) => {
        return this.state.isGpa && (this.isIAAgent || this.isPCSAgent || this.isMetGaUser) && form.formNumber.value
            && (form.formNumber.value.startsWith(MLFormNumberWildcards.AUTO_APPLICATION_FORM)
                || form.formNumber.value.startsWith(MLFormNumberWildcards.HOME_APPLICATION_FORM)
                || form.formNumber.value.startsWith(MLFormNumberWildcards.UMBRELLA_APPLICATION_FORM));
    };

    getSignatureTypeList = () => {
        return this.isSignatureOnFileAvailable(this.state.onetimePaymentForm) ? this.state.appSignatureTypeList : this.state.signatureTypeList;
    };

    onSignatureTypeChange = (code) => {
        this.state.onetimePaymentForm.signatureType.value = this.getSignatureTypeList().find((t) => t.code === code);
        this.refreshData();
    };

    next = () => {
        const policyNumbers = [];
        for (let i = 0; i < this.state.bundledPaymentRequest.paymentRequests.length; ++i) {
            policyNumbers[i] = this.state.bundledPaymentRequest.paymentRequests[i].policyNumber;
        }
        const paymentPromise = MLFormService.inferOneTimePaymentForm(
            policyNumbers,
            this.state.onetimePaymentForm.value,
            this.state.paymentInstrument.token,
            this.state.totalPaymentAmount,
            this.props.authHeader
        );

        showProgressDialog(platformMessages.loading, paymentPromise);
        paymentPromise.then((res) => {
            const translator = this.context;
            
            this.state.onetimePaymentForm.sessionID.value = res.sessionID;
            this.state.onetimePaymentForm.policyPeriodPublicID.value = res.policyPeriodPublicID;
            this.state.onetimePaymentForm.formNumber.value = res.formNumber;
            this.state.onetimePaymentForm.primaryPolicyNumber.value = res.primaryPolicyNumber;
            this.state.onetimePaymentForm.formDescription.value = translator(messages.formDescription);

            this.props.history.push({
                pathname: 'billingAvailableDocuments',
                state: {
                    bundledPaymentRequest: this.state.bundledPaymentRequest,
                    usePaymentusAch: this.state.usePaymentusAch,
                    paymentInstrument: this.state.paymentInstrument,
                    onetimePaymentForm: this.state.onetimePaymentForm.value
                }
            });
            MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Continue`);
        }, (error) => {
            console.error(error);
        });
    };

    render() {
        const translator = this.context;

        const { displayName } = this.props.accountDetailsData.accountHolder;

        const getFaxNumberValidationMessage = () => {
            const value = _.get(this.state.onetimePaymentForm, 'faxNumber.value');
            if (!value) {
                return [translator(messages.requiredField)];
            }
            if (value.length !== 10) {
                return [translator(messages.faxNumberValidationMessage)];
            }
            return undefined;
        };

        const updateFaxNumber = (value) => {
            const unmaskedFaxNumber = value.replace(/[^\d]/g, '');
            this.state.onetimePaymentForm.faxNumber.value = unmaskedFaxNumber;
            this.refreshData();
        };

        const getEmailNumberValidationMessage = () => {
            const value = _.get(this.state.onetimePaymentForm, 'namedInsuredEmail.value');
            if (!value) {
                return [translator(messages.requiredField)];
            }
            const regx = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}/;
            if (!value.match(regx)) {
                return [translator(messages.emailValidationMessage)];
            }
            return undefined;
        };

        const updateEmailNumber = (value) => {
            this.state.onetimePaymentForm.namedInsuredEmail.value = value;
            this.refreshData();
        };

        const disableRequiredSignaturesNext = () => {
            if (!this.state.onetimePaymentForm.signatureType.value) {
                return true;
            }
            if (this.state.onetimePaymentForm.signatureType.value.code === 'fax' &&
                !!getFaxNumberValidationMessage(this.state.onetimePaymentForm.faxNumber.value)) {
                return true;
            }
            if (
                (this.state.onetimePaymentForm.signatureType.value.code === 'email' ||
                    this.state.onetimePaymentForm.signatureType.value.code === 'esignature') &&
                !!getEmailNumberValidationMessage(this.state.onetimePaymentForm.namedInsuredEmail.value)) {
                return true;
            }
            return false;
        };

        const generateFormNameColumn = () => {
            return (
                <div className="font-weight-bold">{translator(messages.formDescription)}</div>
            );
        };

        const generateSignatureTypeColumn = () => {
            return (
                <div className="select">
                    <DropdownSelectField
                        id='signatureTypeSelect'
                        availableValues={this.getSignatureTypeList().map((v) => {
                            return {
                                id: v.code,
                                displayName: { id: v.name, defaultMessage: v.code }
                            };
                        })}
                        onValueChange={this.onSignatureTypeChange}
                        value={_.get(this.state.onetimePaymentForm, 'signatureType.value.code')}
                        searchable
                    />
                </div>
            );
        };

        const generateActionColumn = () => {
            const isUSPS = () => {
                return _.get(this.state.onetimePaymentForm, 'signatureType.value.code') === 'usps';
            };
            const isHardCopy = () => {
                return _.get(this.state.onetimePaymentForm, 'signatureType.value.code') === 'agent_esignature'
                    || _.get(this.state.onetimePaymentForm, 'signatureType.value.code') === 'hard_copy';
            };
            const isFax = () => {
                return _.get(this.state.onetimePaymentForm, 'signatureType.value.code') === 'fax';
            };
            const isEmailOrESignature = () => {
                return _.get(this.state.onetimePaymentForm, 'signatureType.value.code') === 'email'
                    || _.get(this.state.onetimePaymentForm, 'signatureType.value.code') === 'esignature';
            };

            return (
                <>
                    {isUSPS() && (
                        <div className='font-weight-bold'>{translator(messages.sendToMailingAddress)}</div>
                    )}
                    {isHardCopy() && (
                        <div className='font-weight-bold'>{translator(messages.availableForDownload)}</div>
                    )}
                    {isFax() && (
                        <InputMaskField
                            id='fax'
                            alwaysShowMask
                            label={translator(messages.faxNumberLabel)}
                            labelPosition="top"
                            mask="(999) 999-9999"
                            maskChar="#"
                            showErrors
                            value={_.get(this.state.onetimePaymentForm, 'faxNumber.value')}
                            onValueChange={updateFaxNumber}
                            validationMessages={getFaxNumberValidationMessage()}
                            messageProps={{
                                incompleteInput: {
                                    id: 'ml.gateway.views.account-detail.Enter a 10 digit phone number without dashes',
                                    defaultMessage: 'Enter a 10 digit phone number without dashes'
                                }
                            }}
                        />
                    )}
                    {isEmailOrESignature() && (
                        <InputField
                            id='email'
                            label={translator(messages.emailLabel)}
                            labelPosition="top"
                            placeholder={translator(messages.emailPlaceholder, { contactName: displayName })}
                            value={_.get(this.state.onetimePaymentForm, 'namedInsuredEmail.value')}
                            onValueChange={updateEmailNumber}
                            validationMessages={getEmailNumberValidationMessage()}
                        />
                    )}
                </>
            );
        };

        const overrides = {
            formTable: {
                data: [this.state.onetimePaymentForm]
            },
            formNameColumn: {
                cell: generateFormNameColumn
            },
            signatureTypeColumn: {
                cell: generateSignatureTypeColumn
            },
            actionColumn: {
                cell: generateActionColumn
            },
            nextButton: {
                disabled: disableRequiredSignaturesNext()
            },
            nextDescription: {
                content: (
                    <FormattedMessage
                        {...messages.wellReviewDocumentNext}
                        values={{
                            onetimePaymentDocument: (
                                <strong>{translator(messages.onetimePaymentDocument)}</strong>
                            )
                        }}
                    />
                )
            }
        };
        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                next: this.next
            }
        };

        const requiredSignaturePage = <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
        return (
            <div>
                {requiredSignaturePage}
            </div>
        );
    }
}

export const AccountBillingRequiredSignature = MLAccountBillingRequiredSignature;
export default withIntl(withViewModelService(withAuthenticationContext(MLAccountBillingRequiredSignature)));